import { action, computed, observable } from 'mobx'
import { task } from 'mobx-task'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { type OrganizerStep } from '@/features/jobs/details/tax-type/tax-prep-organizer/TaxPrepOrganizerViewModel'

export interface SaveSectionDialogViewModelOptions {
  onSave: (navigate: OrganizerStep) => Promise<void>
  onNavigate: (target: OrganizerStep) => Promise<void>
}

export class SaveSectionDialogViewModel {
  readonly modal = new ModalViewModel()

  @observable accessor currentSection: OrganizerStep | null = null
  @observable accessor targetSection: OrganizerStep | null = null

  constructor(private readonly _options: SaveSectionDialogViewModelOptions) {}

  @computed
  get sectionLabel(): string {
    if (!this.currentSection) return ''
    return this.currentSection
  }

  @action.bound
  showDialog(current: OrganizerStep, target: OrganizerStep) {
    this.currentSection = current
    this.targetSection = target
    this.modal.show()
  }

  @action.bound
  closeDialog() {
    this.modal.close()
    this.currentSection = null
    this.targetSection = null
  }

  saveAndContinue = task.resolved(async () => {
    if (this.targetSection) {
      await this._options.onSave(this.targetSection)
    }
    this.closeDialog()
  })

  @action.bound
  continueWithoutSaving() {
    if (this.targetSection) {
      void this._options.onNavigate(this.targetSection)
    }
    this.closeDialog()
  }
}
